(ns ui.editors.file.event
  (:require-macros [cljs.core.async.macros :as async])
  (:require [cljs-http.client :as http]
            [cljs.core.async :as a]
            [frontend.updates.entity-scope :as entity-scope]
            [potpuri.core :as potpuri]))



(defn add-indicator!
  [state* upload-id file-name]
  (swap! state* assoc-in [:uploading upload-id] {:file-name file-name
                                                 :status    :uploading}))

(defn remove-indicator!
  [state* upload-id]
  (swap! state* potpuri/dissoc-in [:uploading upload-id]))

(defn read-progress
  [channel state* upload-token]
  (a/take!
    channel
    (fn [progress]
      (let [{:keys [direction loaded total]} progress
            prog (/ loaded total)]
        (cond (= :download direction)
              (swap! state* assoc-in [:uploading upload-token :progress] 100.0)
              (= :upload direction)
              (do (swap! state* assoc-in [:uploading upload-token :progress] (* 100 (float prog)))
                  (swap! state* assoc-in [:uploading upload-token :status] :uploading)))
        (when (= :upload direction)
          (read-progress channel state* upload-token))))))

(defn start-upload!
  [{:keys [state* success! error! target-id replace-id data]} file]
  (let [file-name (.-name file)
        upload-id (gensym "file-upload-")
        attachment (merge {:filename    file-name
                           :description nil
                           :file        file
                           :target-id   target-id
                           :data        (pr-str data)}
                          (when replace-id
                            {:replace-id replace-id}))
        prog-channel (a/chan)]
    (add-indicator! state* upload-id (:filename attachment))
    (read-progress prog-channel state* upload-id)
    (async/go
      (let [resp (a/<! (http/post "/upload/api/upload"
                                  {:multipart-params attachment
                                   :progress         prog-channel}))]
        (if (= (:status resp) 200)
          (let [body (:body resp)]
            (swap! state* assoc-in [:uploading upload-id :status] :complete)
            ;; A new-grid account gets no attachments from the sync channels.
            ;; Fetch the new attachment before `success!` reads it.
            (entity-scope/hydrate! {:entity-id (:db/id body)
                                    :on-done   (fn [] (success! body))}))
          (do (swap! state* assoc-in [:uploading upload-id :progress] 0.0)
              (swap! state* assoc-in [:uploading upload-id :status] :error)
              (swap! state* assoc-in [:uploading upload-id :error] (:body resp))
              (when (fn? error!)
                (error! (:body resp)))))))))
